import { handleActions } from "redux-actions";

import {
  SET_LOADING,
  SET_STATUS,
  RESET_FILTERS,
  SET_ERROR,
  FETCH_CHAINS_SUCCESS,
  EDIT_CHAIN_SUCCESS
} from "./chainsSagas";
import sortBy from "lodash/sortBy";

export const initialState = {
  isLoading: true,
  chains: {},
  locations: [],
  status: "idle",
  errors: null
};

export default handleActions(
  {
    [SET_ERROR]: (state, action) => ({
      ...state,
      status: "failed",
      errors: action.payload
    }),
    [SET_STATUS]: (state, action) => ({
      ...state,
      status: action.payload
    }),
    [RESET_FILTERS]: (state) => ({
      ...state,
      status: "idle",
      errors: null
    }),
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [FETCH_CHAINS_SUCCESS]: (state, action) => ({
      ...state,
      chains: action.payload.list,
      commonSettings: action.payload.settings
    }),

    [EDIT_CHAIN_SUCCESS]: (state, { payload: { id, name, orgName } }) => ({
      ...state,
      chains: {
        ...state.chains,
        [orgName]: sortByName(
          state.chains[orgName].map((chain) =>
            chain.id == id ? { ...chain, chainName: name } : chain
          )
        )
      }
    })
  },

  initialState
);

const sortByName = (arr) => {
  return sortBy(arr, (obj) => obj.chainName.toLowerCase());
};
